# WHEN THE /app CLIENT IS DARK — the rules, free of React so a pin can drive
# them (card 6ac075e0270c80c6c2166c4a; color_scheme.coffee applies them).
#
# Dark while BOTH hold: the device asks for it (prefers-color-scheme), and the
# screen on show is not light-only. Owner 2026-10-02: "Not login. Not the
# games." <html> then carries `el-dark`, which defines color_scheme.scss's
# --el-dk-* variables.

export DARK_QUERY = '(prefers-color-scheme: dark)'
export CLASS = 'el-dark'

# Route names that stay light whatever the device says.
export LIGHT_ONLY = ['login', 'logout', 'reset', 'play', 'playSubject', 'playback']

export deviceIsDark = (win = window) ->
  !!win?.matchMedia?(DARK_QUERY)?.matches

# APPEARANCE: AUTO / LIGHT / DARK, PER DEVICE — card 6ac15a50270c80c6c2166c91
# (owner 2026-10-03: "There should be a way to turn off dark mode"). Stored on
# the device like the Classic View choice (hosted/mobile_device.coffee), not on
# the account: it is about this screen, and it works signed out. Absent = Auto,
# which follows the device as before. Light-only screens stay light whatever
# is chosen. setScheme announces the change on the document so the shell's
# provider (and the hosted Mobile Shell row) re-decide without a reload.
export SCHEME_KEY = 'el-color-scheme'
export SCHEME_EVENT = 'el-scheme-changed'
export SCHEMES = ['auto', 'light', 'dark']

export storedScheme = (win = window) ->
  try
    v = win?.localStorage?.getItem(SCHEME_KEY)
    if v in ['light', 'dark'] then v else 'auto'
  catch
    'auto'

# The media for a loading screen's white-text logo <source>, as views/index.ejs
# decides it before the bundle: Light has none (the dark-text <img> shows), Dark
# always shows it, Auto follows the device. A <source> on the device query alone
# turned the logo white on a dark phone set to Light (owner 2026-10-04).
export darkLogoMedia = (win = window) ->
  switch storedScheme(win)
    when 'light' then null
    when 'dark' then 'all'
    else DARK_QUERY

# The class views/index.ejs puts on <html> at page load for the stored choice
# (el-scheme-light / el-scheme-dark; none for Auto). The loading screen's
# background keys on it, the logo on darkLogoMedia — so a choice made from the
# menu must move the class too, or Dark gives the white-text logo on the light
# window (owner 2026-10-06, Android, Continue Coursework; card
# 6ac52ba4d8c560c58ee7bfa6).
export applySchemeClass = (choice, doc = document) ->
  list = doc?.documentElement?.classList
  return unless list?
  for c in ['light', 'dark']
    list.toggle "el-scheme-#{c}", choice == c

export setScheme = (choice, win = window) ->
  try
    if choice in ['light', 'dark'] then win.localStorage.setItem(SCHEME_KEY, choice)
    else win.localStorage.removeItem(SCHEME_KEY)
  catch
    # storage refused: the choice lasts for this page
  applySchemeClass storedScheme(win), win?.document
  win?.document?.dispatchEvent? new win.Event(SCHEME_EVENT)
  storedScheme win

# The next choice round the menu: Auto -> Light -> Dark -> Auto.
export nextScheme = (current) -> SCHEMES[(SCHEMES.indexOf(current) + 1) % SCHEMES.length]

export darkFor = (routeName, deviceDark, choice = 'auto') ->
  return false if routeName in LIGHT_ONLY
  switch choice
    when 'light' then false
    when 'dark' then true
    else !!deviceDark

# The light color, or the dark one while the page is dark — for what CSS
# variables cannot reach (Highcharts options, canvas).
export schemeColor = (light, dark, doc = document) ->
  if doc?.documentElement?.classList?.contains(CLASS) then dark else light

export isDark = (doc = document) ->
  !!doc?.documentElement?.classList?.contains(CLASS)

# Calls fn whenever the page switches between light and dark (a chart redraws
# its options); answers the unsubscribe.
export onSchemeChange = (fn, doc = document) ->
  return (->) unless doc?.documentElement? and window.MutationObserver?
  last = isDark(doc)
  observer = new MutationObserver ->
    now = isDark(doc)
    return if now == last
    last = now
    fn(now)
  observer.observe doc.documentElement, {attributes: true, attributeFilter: ['class']}
  -> observer.disconnect()

export applyClass = (dark, doc = document) ->
  doc?.documentElement?.classList?.toggle(CLASS, dark)
